<template>
    <select2 :value="value"
             @input="$emit('input', $event)"
             :plugin-options="studentsSelect2Options"
             :dropdown-parent-selector="dropdownParentSelector"
             :additional-fields="['data']"
             :is-ajax="true"
             class="form-control"></select2>
</template>
<script>
import StudentFormats from "@/models/studentFormats";

const SearchStudentsComponent = {
    props: ["dropdownParentSelector", "courseGroupId", "value", "url", "data", "originalStudentId", "showMiddleName"],

    data() {
        return {
            studentsSelect2Options: {
                minimumInputLength: 2,
                allowClear: true,
                width: "100%",
                placeholder: this.$t("enrollments.student"),
                ajax: {
                    url: this.url || "/api/Enrollment/SearchStudents",
                    delay: 250,
                    data: this.data || (params => (this.getRequest(params))),
                    processResults: data => {
                        return {
                            results: data.map(item => ({
                                id: item.studentId,
                                text: StudentFormats.formatStudent(item, this.showMiddleName),
                                data: item
                            }))
                        };
                    }
                }
            }
        };
    },

    methods: {
        getRequest(params) {
            const request = {
                term: params.term
            };

            if (this.courseGroupId) {
                request.courseGroupId = this.courseGroupId;
            }

            if (this.originalStudentId) {
                request.originalStudentId = this.originalStudentId;
            }

            return request;
        }
    }
};

export default SearchStudentsComponent;
</script>